import { Component, Input, OnInit } from '@angular/core';
import { TaxPayerDialogComponent } from '../dialogs/tax-payer-dialog/tax-payer-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MergeUsersDialogComponent } from '../dialogs/merge-users-dialog/merge-users-dialog.component';
import { CompanyRepresentativeService } from 'src/app/services/companyRepresentative.service';
import { TranslateService } from '@ngx-translate/core';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component';
import { UserService } from 'src/app/services/user.service';
import { ProcessService } from 'src/app/services/process.service';
import { TaxPayerService } from 'src/app/services/taxPayer.service';
import { sanitizeReportHtml } from "src/app/util/sanitize-report-html";
@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.css']
})
export class CompanyProfileComponent implements OnInit {
  @Input() company: any;
  @Input() canUpdate = true;
  user
  loading = { inProgress: false, downloadInProgress: false }
  constructor
  (
    public dialog: MatDialog,
    private companyRepresentativeService: CompanyRepresentativeService,
    private translate: TranslateService,
    private userService: UserService,
    private processService: ProcessService,
    private taxPayerService: TaxPayerService
  ) { }

  ngOnInit() {
    this.userService.getCurrentUser().subscribe(u => this.user = u);
  }

  canArchive() {
    if (!this.user) return false;
    return ['ADMIN', 'FINANCIAL_EDITOR'].includes(this.user.role);
  }
  canRevive() {
    if (!this.user) return false;
    return this.user.role === 'ADMIN' && this.company?.archived;
  }

  reviveCompany() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { text: 'DIALOG.CONFIRM_REVIVE_TAXPAYER', action: 'CONFIRM_REVIVE' }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
  
        const saveRevive = {
          type: 'REVIVE',
          tin: this.company.tin,
          companyName: this.company.name,
          municipalityId: this.company.municipality?.id,
          municipalityName: this.company.municipality?.name,
          details: {
            archivedTin: this.company.tin,
            archivedCompany: this.company.name
          }
        };
  
        this.taxPayerService.saveNotificationData(saveRevive).subscribe({
          next: () => {
            this.taxPayerService.reviveTaxpayer(this.company.tin).subscribe({
              next: () => {
                this.company.archived = false;
                window.location.reload();
              },
              error: err => console.error('Revive error', err)
            });
          },
          error: err => console.error('Notification save error', err)
        });
      }
    });
  }

  archiveCompany() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { text: 'DIALOG.CONFIRM_ARCHIVE_TAXPAYER', action: 'CONFIRM_ARCHIVE' }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
  
        const saveArchive = {
          type: 'ARCHIVE',
          tin: this.company.tin,
          companyName: this.company.name,
          municipalityId: this.company.municipality?.id,
          municipalityName: this.company.municipality?.name,
          details: {
            archivedTin: this.company.tin,
            archivedCompany: this.company.name
          }
        };
  
        this.taxPayerService.saveNotificationData(saveArchive).subscribe({
          next: () => {
            this.processService.archiveCompany(this.company.tin).subscribe({
              next: () => {
                this.taxPayerService.archiveTaxpayer(this.company.tin).subscribe({
                  next: () => {
                    window.location.reload();
                  },
                  error: err => console.error('Atom archive error', err)
                });
              },
              error: err => console.error('Process archive error', err)
            });
          },
          error: err => console.error('Notification save error', err)
        });
      }
    });
  }

  getName(addT) {
    if (addT.name)
      return addT.name[localStorage.getItem('default_lang')] || addT.name['en'] || addT.name
    return ''
  }
  onSendSmsCheckClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    let text = this.company['sendSms'] ? 'DIALOG.DISABLE_SMS_NOTIFICATIONS_CONFIRMATION' : 'DIALOG.ENABLE_SMS_NOTIFICATIONS_CONFIRMATION';

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: '500px',
          data: { text: text, emitter: null,  action: "CONFIRM_SMS" }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.company['sendSms'] = !this.company['sendSms'];
                this.companyRepresentativeService.setSmsStatus(this.company).subscribe(res => {
                  console.log('SMS preference updated');
                })
          }
        });
  }
  getValue(addT) {
    const val = this.company.additionalFields[addT.key];
    if (val) {
      const raw = val.name || val;
      if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(raw)) {
        return raw.split('T')[0];
      }
      return raw;
    }
    return '';
  }

  getCreator() {
    if (this.company['createdBy']) {
      let createdBy = this.company['createdBy']
      let name = createdBy['name'] && createdBy['name'] !== null ? createdBy['name'] : ''
      let surname = createdBy['name'] && createdBy['name'] !== null ? ' ' + createdBy['surname'] : ''
      let username = createdBy['name'] && createdBy['name'] !== null ? ' (' + createdBy['username'] + ')' : ''
      return name + surname + username
    }
    return ''
  }

  openTaxPayerDialog(taxPayer): void {
    this.dialog.open(TaxPayerDialogComponent, {
      width: '800px', panelClass: 'custom-dialog-container',
      data: taxPayer
    });
  }

  mergeUsersDialog(): void {
    const dialogRef = this.dialog.open(MergeUsersDialogComponent, {
      width: '700px', panelClass: 'custom-dialog-container',
      data: this.company
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
  async downloadCompanyPdf() {
    let companyData = await this.companyRepresentativeService.getCompanyData(this.company.tin).toPromise()
    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.width = "100%";
    container.innerHTML = sanitizeReportHtml(companyData)
    document.body.appendChild(container);
    html2canvas(container, { allowTaint: true, useCORS: true })
      .then((canvas) => {
        document.body.removeChild(container);
        const imgData = canvas.toDataURL("image/jpeg", 0.7);
        const pdf = new jsPDF();
        const imgWidth = 190;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "JPEG", 10, 10, imgWidth, imgHeight);
        pdf.save("Company-" + this.company['tin'] + "-content.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  }

}
